/**
 * MechaGuard - PlasmaTower (等离子炮)
 *
 * 攻击方式：发射追踪弹，命中后产生范围溅射。
 * 定位：对付密集敌群的通用输出塔。
 * 满级特性：溅射半径与溅射比例提升。
 */

import { Tower } from '../entities/Tower.js';

export class PlasmaTower extends Tower {
  static META = {
    id: 'plasma',
    name: '等离子炮',
    icon: '🔥',
    cost: 150,
    desc: '追踪炮弹，命中后范围溅射',
    color: '#ff9900',
    stats: {
      baseRange: 132,
      baseDamage: 34,
      fireInterval: 1.2,   // ≈ 28.3 DPS（溅射后实际更高）
      barrelLength: 18,
      turnSpeed: 7,
      firingFx: 0.14,
      projectileSpeed: 430,
      splashRadius: 56,
      splashFactor: 0.5,
      splashRadiusMul: 1.3,  // 满级溅射半径乘数
      splashFactorMul: 1.4,  // 满级溅射比例乘数
    },
  };

  constructor(col, row) {
    super(col, row);
  }

  /** 满级溅射更强 */
  get effectiveSplashRadius() {
    return this.level >= 3 ? this.splashRadius * this.splashRadiusMul : this.splashRadius;
  }

  get effectiveSplashFactor() {
    return this.level >= 3 ? this.splashFactor * this.splashFactorMul : this.splashFactor;
  }

  update(dt, game) {
    this.tickTimers(dt);

    const target = this.findTarget(game.enemies);
    this.target = target;

    if (!target) return;

    this.aimAt(target, dt, this.turnSpeed);

    if (this.cooldown > 0) return;

    this.cooldown = this.fireInterval;
    this.firing = this.firingFx;
    game.sfx('plasma');

    const mx = this.x + Math.cos(this.angle) * this.barrelLength;
    const my = this.y + Math.sin(this.angle) * this.barrelLength;

    game.spawnProjectile({
      mode: 'homing',
      x: mx,
      y: my,
      target,
      source: this,
      speed: this.projectileSpeed,
      damage: this.damage,
      splashRadius: this.effectiveSplashRadius,
      splashFactor: this.effectiveSplashFactor,
      color: this.color,
      size: 5,
      trail: true,
    });

    game.particles.spawnMuzzle(mx, my, this.angle, this.color);
  }

  drawTurret(ctx, accent) {
    // 粗壮炮管
    ctx.fillStyle = 'rgba(10, 24, 42, 0.92)';
    ctx.strokeStyle = accent;
    ctx.lineWidth = 2;

    ctx.beginPath();
    ctx.rect(-9, -8, 14, 16);
    ctx.fill();
    ctx.stroke();

    ctx.beginPath();
    ctx.rect(3, -5, 16, 10);
    ctx.fill();
    ctx.stroke();

    // 炮口能量
    ctx.shadowColor = accent;
    ctx.shadowBlur = 12;
    ctx.fillStyle = accent;
    ctx.beginPath();
    ctx.arc(19, 0, 3.4, 0, Math.PI * 2);
    ctx.fill();
    ctx.shadowBlur = 0;

    // 冷却环（视觉反馈装填进度）
    const progress = Math.max(0, Math.min(1, 1 - this.cooldown / this.fireInterval));
    ctx.strokeStyle = 'rgba(255, 255, 255, 0.65)';
    ctx.lineWidth = 2;
    ctx.beginPath();
    ctx.arc(0, 0, 10, -Math.PI / 2, -Math.PI / 2 + progress * Math.PI * 2);
    ctx.stroke();
  }
}
